// Imports
import React, { useState } from "react";
import chevronDown from "src/files/chevron-down.svg";

function QuizScreenHowItWorks() {
  const [isExpanded, setIsExpanded] = useState(false);

  const steps=["Answer the following set of questions","Based on your answers, we will recommend an assortment of information to help you self-regulate or make changes to your driving behaviours.  ","The information is bookmarked so you will have easy access to the information at any time in the future when you might want to refresh your memory."];

  const endDescription = "The Senior Road User Hub Quiz is informed by research with input from specialists in the fields of geriatrics, psychology and road safety. It is not a diagnostic test or assessment tool. You will not need to provide any personal information or details, while your answers will be only visible to you.  "

  const handleToggle = (e) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);

    document.querySelector('.quiz-screen-start').classList.toggle('hide-bg-img');
    document.querySelector('.quiz-screen-start__container').scrollTo({ top: 0, behavior: 'smooth' });
    
    // Handle opacity transitions for title, subtitle, decoration, and buttons
    const title = document.querySelector('.quiz-screen-start__title');
    const subtitle = document.querySelector('.quiz-screen-start__subtitle');
    const decoration = document.querySelector('.quiz-screen-start__decoration');
    const buttons = document.querySelectorAll('.quiz-screen-start__button-group .button--large');
    
    if (isExpanded) {
      // Collapsing - fade in with 800ms delay
        title.style.opacity = '1';
        subtitle.style.opacity = '1';
        decoration.style.opacity = '1';
        buttons.forEach(button => {
          button.style.opacity = '1';
        });
    } else {
      // Expanding - fade out immediately
      title.style.opacity = '0';
      subtitle.style.opacity = '0';
      decoration.style.opacity = '0';
      buttons.forEach(button => {
        button.style.opacity = '0';
      });
    }
  };

  return (
    <div className="quiz-how-it-works">
      {/* Placeholder to maintain space when button is absolutely positioned */}
      <div className={`quiz-how-it-works__placeholder ${isExpanded ? 'expanded' : ''}`}>
        <span>How it works buttonplaceholder</span>
      </div>
      
      <div className={`quiz-how-it-works__container ${isExpanded ? 'expanded' : ''}`}>
        {/* Button at top */}
        <a
          href="#"
          className={`quiz-how-it-works__toggle ${isExpanded ? 'expanded' : ''}`}
          onClick={handleToggle}
          aria-expanded={isExpanded}
        >
          <span>How it works</span> 
          <img src={chevronDown} alt="chevron down" />
        </a>
        
        {/* Content below button */}
        <div className={`quiz-how-it-works__content ${isExpanded ? 'expanded' : ''}`}>
          <div className="quiz-how-it-works__content-inner">
            <ol className="quiz-how-it-works__steps">
              {steps.map((step, index) => (
                <li key={index} className="quiz-how-it-works__step">
                  <span className="quiz-how-it-works__step-number">{index + 1}</span>
                  <p className="quiz-how-it-works__step-description">{step}</p>
                </li>
              ))}
            </ol>
            <p className="quiz-how-it-works__description">{endDescription}</p>
          </div>
        </div>
      </div>
      
      
      
    </div>
  );
}

export default QuizScreenHowItWorks;
